import { __decorate } from "tslib";
/**
 * 通知卡片组件
 * 组件使用场景：首页通知卡片
 * @params  title[String] : '' 标题,
 * @params  onClick[Function] : () => {}  操作区域点击回调,
 * */
import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from '@souche-f2e/muji';
const Root = styled.div `
  border: 1px solid #E4E4E4;
  .notice-title{
    border-left: 2px solid #726766;
    font-size: 18px;
    line-height: 18px;
    color: #666666;
    margin: 20px;
    margin-bottom: 10px;
    padding-left:10px;
   }
  .notice-msg{
    height:230px;
    overflow-y: auto;
    .msg-item{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding:0 60px 0 30px;
      margin-bottom: 5px;
      .msg-title{
        color:#333333;
        font-size: 14px;
        line-height: 15px;
        // padding: 2px 0;
        min-height:45px;
        cursor: pointer;
        .hight-color{
          font-weight: bold;
        }
      }
      .msg-time{
        color:#333333;
        flex-shrink: 0;
      }
    }
    .ui-noData{
      height:100%;
      font-size:18px;
      display: flex;
      align-items: center;
      justify-content:center;
    }
  }
  .notice-operate{
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #EBEBEB;
    padding:10px 60px 10px 40px;
    .tip{
      display: flex;
      align-items: center;
      .wait-deal{
        width:5px;
        height:5px;
        border-radius: 50%;
        background: #4FA965;
        margin-right: 5px;
      }
    }
    .operate{
      color:#ff571a;
      cursor: pointer;
    }
    .operate:after{
      content:'>';
      margin-left:10px;
    }
  }
  `;
const mapStateToProps = (rootState) => ({
    home: rootState.home,
});
// @ts-ignore
let NoticeCard = class NoticeCard extends Component {
    constructor(props) {
        super(props);
    }
    msgItem(data, index, t) {
        /**
         * 车辆发拍审批
         * 文案格式：【经销商名称】／【车型】／【车牌号】／【上牌时间】／【表显里程】／【保留价】--高亮／申请发拍 ，提交时间（格式：2017-09-25 15:51:24）；
         * 如：xxx门店提交日产/轩逸/2012年 1.6l 自动 xl豪华经典版 浙F89897 2017-12-13 1.3万公里 保留价10.00万 申请发拍；
         *
         * 财务审批
         * 文案格式：【经销商名称】／【车型】／车牌号】／【上牌时间】／【表显里程】／【成交价】--高亮／申请卖家付款 ，提交时间（格式：2017-09-25 15:51:24）；
         * 如：xxx提交日产/轩逸/2012年 1.6l 自动 xl豪华经典版 浙F89897 2017-12-13 1.3万公里 成交价10.00万 申请卖家付款；
         */
        let luBanId = null;
        if (t === 'car') {
            luBanId = 'PSGJB-HOME-CLFPSPKP';
        }
        if (t === 'money') {
            luBanId = 'PSGJB-HOME-CWSPKP';
        }
        return (<div className="msg-item" key={data.key || index}>
        <div className="msg-title" onClick={this.props.onClick} luban-id={luBanId}>
          <div>
            {t === 'car' && (<div>
                  <span className={'hight-color'}>
                    {data.sellerName && ( // 经销商名称:
        <span>{data.sellerName}/</span>)}
                    {data.carModelName && ( // 车型:
        <span>{data.carModelName}/</span>)}
                    {data.license && ( // 车牌号:
        <span>{data.license}/</span>)}
                    {data.RegisterDate && ( // 上牌时间:
        <span>{data.RegisterDate}/</span>)}
                    {data.mileage && ( // 表显里程:
        <span>{data.mileage}/</span>)}
                    {data.basePriceYuan && ( // 保留价:
        <span>{data.basePriceYuan}元</span>)}
                  </span>
                  <span>  申请发拍</span>
                </div>)}
            {t === 'money' && (<div>
                  <span className={'hight-color'}>
                    {data.sellerName && (<span>{data.sellerName}/</span>)}
                    {data.goodsName && (<span>{data.goodsName}/</span>)}
                    {data.carLicense && (<span>{data.carLicense}/</span>)}
                    {data.registTime && (<span>{data.registTime}/</span>)}
                    {data.mileage && (<span>{data.mileage}/</span>)}
                    {data.sellerPriceYuanUnit && (<span>{data.sellerPriceYuanUnit}元</span>)}
                    <span>  申请向卖家付款</span>
                  </span>
                </div>)}
          </div>
        </div>
        <div className="msg-time">
          <div>
            {t === 'car' && (<span>{data.createTime}</span>)}
            {t === 'money' && (<span>{data.orderPayCreateTime}</span>)}
          </div>
        </div>
      </div>);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { title } = nextProps;
        if (title === '财务审批') {
            if ((nextProps.home.moneyList === this.props.home.moneyList) && (this.props.home.moneyNum === nextProps.home.moneyNum)) {
                return false;
            }
        }
        if (title === '车辆发拍审批') {
            if ((nextProps.home.carList === this.props.home.carList) && (this.props.home.carNum === nextProps.home.carNum)) {
                return false;
            }
        }
        return true;
    }
    render() {
        const { title, } = this.props;
        // tslint:disable-next-line:one-variable-per-declaration
        let msgList = [], count = 0, t = '', luBanId = null;
        if (title === '车辆发拍审批') {
            msgList = this.props.home.carList;
            t = 'car';
            luBanId = 'PSGJB-HOME-CLFPSPKP';
            count = this.props.home.carNum;
            // tslint:disable-next-line:brace-style
        }
        else if (title === '财务审批') {
            msgList = this.props.home.moneyList;
            t = 'money';
            luBanId = 'PSGJB-HOME-CWSPKP';
            count = this.props.home.moneyNum;
        }
        let tip = '';
        if (msgList && msgList.length > 0) {
            tip = `您有${count}个待审批申请任务`;
            // tslint:disable-next-line:brace-style
        }
        else {
            tip = '暂无待审批申请任务';
        }
        return (<Root className="notic-box">
        <div className="notice-title">{title}</div>
        <div className="notice-msg">
          {msgList.length > 0 &&
            msgList.map((v, i) => this.msgItem(v, i, t))}
          {msgList.length === 0 &&
            (<div className="ui-noData">
              <span>暂无数据</span>
            </div>)}
        </div>
        <div className="notice-operate">
          <div className="tip">
            {tip && (<div className="wait-deal"/>)}
            {tip}
          </div>
          <div className="operate" onClick={this.props.onClick} luban-id={luBanId}>前往处理</div>
        </div>
      </Root>);
    }
};
NoticeCard = __decorate([
    connect(mapStateToProps)
], NoticeCard);
export default NoticeCard;
